import { render } from "./OldAccounts.vue?vue&type=template&id=27c358c6&scoped=true"
import script from "./OldAccounts.vue?vue&type=script&lang=js"
export * from "./OldAccounts.vue?vue&type=script&lang=js"

import "./OldAccounts.vue?vue&type=style&index=0&id=27c358c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c358c6"]])

export default __exports__